import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { useSelector } from 'react-redux';

export const ModalNotaItem = ({ open, close, titulo, comentario, carMin, carMax, setComentario, handleSaveLine, esCodigoLiquidacion, grabarDebito = false, idMotivoDebito, setIdMotivoDebito }) => {

  const { motivosDebito = {} } = useSelector(
    (state) => state.liquidaciones
  );



  const [error, setError] =
    useState((((!comentario || comentario?.length < carMin) && !esCodigoLiquidacion) || comentario?.length > carMax) ? true : false);

  const onChangeTextAreaHandler = (e) => {
    const hayError =
      e?.target?.value?.length < carMin || e?.target?.value?.length === carMax;
    setError(hayError);
    if (e?.target?.value?.length < carMax) {
      setComentario(e.target.value);
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} /* onClose={close} */>
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} /* style={{ margin: "2rem 0" }} */>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              label="Comentario"
              name="comentario"
              value={comentario ?? ''}
              onChange={onChangeTextAreaHandler}
              error={error}
              helperText={error && `Este campo es requerido con un mínimo de ${carMin} caracteres y un máximo de ${carMax}`}
            />
          </Grid>
          {grabarDebito &&
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" error={error}>
                <InputLabel>Motivo Débito</InputLabel>
                <Select
                  value={idMotivoDebito ?? 0}
                  onChange={(e)=> setIdMotivoDebito(e.target.value)}
                  label="Motivo"
                >
                  {motivosDebito.map((motivo) => (
                    <MenuItem key={motivo.idMotivoDebito} value={motivo.idMotivoDebito}>
                      {motivo.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          }
        </Grid>
        <div
          style={{
            display: "flex",
            margin: "35px 0px 1rem",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <Button variant="contained" color="primary" onClick={close}>
            Cancelar
          </Button>
          <Button
            onClick={handleSaveLine}
            variant="contained"
            disabled={error}
            color="primary"
          >
            Guardar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
